<template>
  <div>
    <slot :months="months"></slot>
  </div>
</template>

<script>
import { eachMonthOfInterval, startOfMonth } from 'date-fns'
import { getYear } from 'date-fns/esm'
export default {
  name: 'GeneratorMonths',
  props: {
    startDate: {type: Date, required: true},
    endDate: {type: Date, required: true},
    year: {type: Number, required: false}
  },
  computed: {
    months () {
      return eachMonthOfInterval({
        start: startOfMonth(this.startDate), 
        end: this.endDate
      })
        .filter(date => !this.year || getYear(date) === this.year)
        .map(month => ({text: month.toLocaleString('fr-FR', {month: 'long'}), value: month}))
    },
  },
}
</script>